import { render, staticRenderFns } from "./NewTaskResource.vue?vue&type=template&id=1e30ef0d"
import script from "./NewTaskResource.vue?vue&type=script&lang=js"
export * from "./NewTaskResource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports